/**
 * Error raised by the calculation engine when input cannot produce a
 * correct result. `code` is stable and safe to expose to API clients.
 */
export type CoreErrorCode =
  | 'INVALID_AMOUNT'
  | 'INVALID_CURRENCY'
  | 'INVALID_EXCHANGE_RATE'
  | 'NO_PARTICIPANTS'
  | 'DUPLICATE_PARTICIPANT'
  | 'INVALID_SPLIT_VALUE'
  | 'SPLIT_SUM_MISMATCH'
  | 'PERCENTAGE_SUM_INVALID'
  | 'UNBALANCED_LEDGER'
  | 'INVALID_KHQR';

export class CoreError extends Error {
  constructor(
    public readonly code: CoreErrorCode,
    message: string,
  ) {
    super(message);
    this.name = 'CoreError';
  }
}
